// account
export const LOGIN = 'login';
export const LOGIN_OAUTH = 'loginOAuth';
export const SIGNUP = 'signup';
export const SIGNUP_OAUTH = 'signupOAuth';
export const LOGOUT = 'logout';
export const UPDATE_ACCOUNT = 'updateAccount';
export const FORGOT_PASSWORD = 'forgotPassword';
export const RESET_PASSWORD = 'resetPassword';
export const RESET_PASSWORD_AUTHED = 'resetPasswordAuthed';
export const SET_PASSWORD_AND_VERIFY = 'resetPasswordAndVerify';
export const REQUEST_SET_PASSWORD_AND_VERIFY = 'requestSetPasswordAndVerify';
export const GET_AUTH_ACCOUNT = 'getAuthAccount';
export const REQUEST_EMAIL_VERIFICATION = 'requestEmailVerification';
export const VERIFY_EMAIL = 'verifyEmail';
export const CLEAR_ACCOUNT_ISLOADING = 'clearAccountIsLoading';

// organization
export const REGISTER_ORGANIZATION = 'registerOrganization';
export const SIGNUP_ORGANIZATION = 'signupOrganization';
export const GET_ORGANIZATIONS = 'getOrganizations';
export const GET_ORGANIZATION = 'getOrganization';
export const EDIT_ORGANIZATION = 'editOrganization';
export const EDIT_YURTZEITEN_DISPLAY = 'editYurtzeitenDisplay';
export const DELETE_ORGANIZATION = 'deleteOrganization';
export const CLEAR_ORGANIZATION_ISLOADING = 'clearOrganizationIsLoading';

// donation
export const REGISTER_DONATION = 'registerDonation';
export const GET_DONATIONS = 'getDonations';
export const EXPORT_DONATIONS = 'exportDonations';
export const TOGGLE_DONATION_IS_ACTIVE = 'toggleDonationIsActive';
export const MOVE_DONATION_TO_FOLDER = 'moveDonationToFolder';
export const BULK_MOVE_DONATIONS_TO_FOLDER = 'bulkMoveDonationsToFolder';
export const EDIT_DONATION = 'editDonation';
export const DELETE_DONATION = 'deleteDonation';
export const BULK_DELETE_DONATIONS = 'bulkDeleteDonations';
export const CLEAR_DONATION_ISLOADING = 'clearDonationIsLoading';

// folder
export const REGISTER_FOLDER = 'registerFolder';
export const GET_FOLDERS = 'getFolders';
export const EDIT_FOLDER = 'editFolder';
export const DELETE_FOLDER = 'deleteFolder';
export const CLEAR_FOLDER_ISLOADING = 'clearFolderIsLoading';

// announcement
export const REGISTER_ANNOUNCEMENT = 'registerAnnouncement';
export const GET_ANNOUNCEMENTS = 'getAnnouncements';
export const EXPORT_ANNOUNCEMENTS = 'exportAnnouncements';
export const TOGGLE_ANNOUNCEMENT_IS_ACTIVE = 'toggleAnnouncementIsActive';
export const MOVE_ANNOUNCEMENT_TO_FOLDER = 'moveAnnouncementToFolder';
export const BULK_MOVE_ANNOUNCEMENTS_TO_FOLDER = 'bulkMoveAnnouncementsToFolder';
export const EDIT_ANNOUNCEMENT = 'editAnnouncement';
export const DELETE_ANNOUNCEMENT = 'deleteAnnouncement';
export const BULK_DELETE_ANNOUNCEMENTS = 'bulkDeleteAnnouncements';
export const CLEAR_ANNOUNCEMENT_ISLOADING = 'clearAnnouncementIsLoading';

// template
export const REGISTER_TEMPLATE = 'registerTemplate';
export const GET_TEMPLATES = 'getTemplates';
export const EDIT_TEMPLATE = 'editTemplate';
export const DELETE_TEMPLATE = 'deleteTemplate';
export const CLEAR_TEMPLATE_ISLOADING = 'clearTemplateIsLoading';

export const REGISTER_EVENT_TEMPLATE = 'registerEventTemplate';
export const GET_EVENT_TEMPLATES = 'getEventTemplates';
export const EDIT_EVENT_TEMPLATE = 'editEventTemplate';
export const DELETE_EVENT_TEMPLATE = 'deleteEventTemplate';
export const CLEAR_EVENT_TEMPLATE_ISLOADING = 'clearEventTemplateIsLoading';

// screen
export const REGISTER_SCREEN = 'registerScreen';
export const GET_SCREENS = 'getScreens';
export const GET_SCREENS_UNPOPULATED = 'getScreensUnpopulated';
export const GET_SCREEN = 'getScreen';
export const REFRESH_SCREEN = 'refreshScreen';
export const EDIT_SCREEN = 'editScreen';
export const DELETE_SCREEN = 'deleteScreen';
export const CLEAR_SCREEN_ISLOADING = 'clearScreenIsLoading';

// yurtzeiten
export const REGISTER_YURTZEITEN = 'registerYurtzeiten';
export const GET_YURTZEITENS = 'getYurtzeitens';
export const GET_YURTZEITEN = 'getYurtzeiten';
export const EDIT_YURTZEITEN = 'editYurtzeiten';
export const DELETE_YURTZEITEN = 'deleteYurtzeiten';
export const CLEAR_YURTZEITEN_ISLOADING = 'clearYurtzeitenIsLoading';

// yurtzeiten_template
export const REGISTER_YURTZEITEN_TEMPLATE = 'registerYurtzeitenTemplate';
export const GET_YURTZEITEN_TEMPLATES = 'getYurtzeitenTemplates';
export const GET_YURTZEITEN_TEMPLATE = 'getYurtzeitenTemplate';
export const EDIT_YURTZEITEN_TEMPLATE = 'editYurtzeitenTemplate';
export const DELETE_YURTZEITEN_TEMPLATE = 'deleteYurtzeitenTemplate';
export const TOGGLE_YURTZEITEN_TEMPLATE_IS_ACTIVE = 'toggleYurtzeitenTemplateIsActive';
export const CLEAR_YURTZEITEN_TEMPLATE_ISLOADING = 'clearYurtzeitenTemplateIsLoading';

// yurtzeiten_email_template
export const REGISTER_YURTZEITEN_EMAIL_TEMPLATE = 'registerYurtzeitenEmailTemplate';
export const GET_YURTZEITEN_EMAIL_TEMPLATES = 'getYurtzeitenEmailTemplates';
export const GET_YURTZEITEN_EMAIL_TEMPLATE = 'getYurtzeitenEmailTemplate';
export const EDIT_YURTZEITEN_EMAIL_TEMPLATE = 'editYurtzeitenEmailTemplate';
export const DELETE_YURTZEITEN_EMAIL_TEMPLATE = 'deleteYurtzeitenEmailTemplate';
export const TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_ACTIVE = 'toggleYurtzeitenEmailTemplateIsActive';
export const TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_DEFAULT = 'toggleYurtzeitenEmailTemplateIsDefault';
export const CHANGE_YURTZEITEN_EMAIL_TEMPLATE_CATEGORY = 'changeYurtzeitenEmailTemplateCategory';
export const CLEAR_YURTZEITEN_EMAIL_TEMPLATE_ISLOADING = 'clearYurtzeitenEmailTemplateIsLoading';

// recentPhoto
export const REGISTER_RECENT_PHOTO = 'registerRecentPhoto';
export const GET_RECENT_PHOTOS = 'getRecentPhotos';
export const GET_RECENT_PHOTO = 'getRecentPhoto';
export const EDIT_RECENT_PHOTO = 'editRecentPhoto';
export const TOGGLE_RECENT_PHOTO_IS_ACTIVE = 'toggleRecentPhotoIsActive';
export const DELETE_RECENT_PHOTO = 'deleteRecentPhoto';
export const CLEAR_RECENT_PHOTO_ISLOADING = 'clearRecentPhotoIsLoading';

// event
export const REGISTER_EVENT = 'registerEvent';
export const GET_EVENTS = 'getEvents';
export const GET_UPCOMING_EVENTS = 'getUpcomingEvents';
export const GET_EVENT = 'getEvent';
export const EDIT_EVENT = 'editEvent';
export const DELETE_EVENT = 'deleteEvent';
export const CLEAR_EVENT_ISLOADING = 'clearEventIsLoading';

// weeklyEvent
export const REGISTER_WEEKLY_EVENT = 'registerWeeklyEvent';
export const GET_WEEKLY_EVENTS = 'getWeeklyEvents';
export const GET_WEEKLY_EVENT = 'getWeeklyEvent';
export const EDIT_WEEKLY_EVENT = 'editWeeklyEvent';
export const DELETE_WEEKLY_EVENT = 'deleteWeeklyEvent';
export const CLEAR_WEEKLY_EVENT_ISLOADING = 'clearWeeklyEventIsLoading';

// weeklySchedule_N
export const GET_WEEKLY_SCHEDULES_N = 'getWeeklySchedules_N';
export const REGISTER_WEEKLY_SCHEDULE_N = 'registerWeeklySchedule_N';
export const EDIT_WEEKLY_SCHEDULE_N = 'editWeeklySchedule_N';
export const TOGGLE_WEEKLY_SCHEDULE_N = 'toggleWeeklySchedule_N';
export const DUPLICATE_WEEKLY_SCHEDULE_N = 'duplicateWeeklySchedule_N';
export const DELETE_WEEKLY_SCHEDULE_N = 'deleteWeeklySchedule_N';
export const GET_WEEKLY_SCHEDULE_N = 'getWeeklySchedule_N';
export const REGISTER_WEEKLY_SCHEDULE_TEMPLATE_N = 'registerWeeklyScheduleTemplate_N';
export const EDIT_WEEKLY_SCHEDULE_TEMPLATE_N = 'editWeeklyScheduleTemplate_N';
export const ACTIVATE_WEEKLY_SCHEDULE_TEMPLATE_N = 'activateWeeklyScheduleTemplate_N';
export const DUPLICATE_WEEKLY_SCHEDULE_TEMPLATE_N = 'duplicateWeeklyScheduleTemplate_N';
export const DELETE_WEEKLY_SCHEDULE_TEMPLATE_N = 'deleteWeeklyScheduleTemplate_N';
export const REGISTER_WEEKLY_SCHEDULE_ITEM_N = 'registerWeeklyScheduleItem_N';
export const EDIT_WEEKLY_SCHEDULE_ITEM_N = 'editWeeklyScheduleItem_N';
export const DUPLICATE_WEEKLY_SCHEDULE_ITEM_N = 'duplicateWeeklyScheduleItem_N';
export const COPY_WEEKLY_SCHEDULE_DAY_N = 'copyWeeklyScheduleDay_N';
export const VERIFY_WEEKLY_SCHEDULE_ITEM_N = 'verifyWeeklyScheduleItem_N';
export const DELETE_WEEKLY_SCHEDULE_ITEM_N = 'deleteWeeklyScheduleItem_N';
export const SAVE_WEEKLY_SCHEDULE_OVERRIDE_N = 'saveWeeklyScheduleOverride_N';
export const DELETE_WEEKLY_SCHEDULE_OVERRIDE_N = 'deleteWeeklyScheduleOverride_N';
export const SAVE_WEEKLY_SCHEDULE_DAY_NOTE_N = 'saveWeeklyScheduleDayNote_N';
export const DELETE_WEEKLY_SCHEDULE_DAY_NOTE_N = 'deleteWeeklyScheduleDayNote_N';
export const SAVE_WEEKLY_SCHEDULE_DISPLAYS_N = 'saveWeeklyScheduleDisplays_N';
export const SAVE_WEEKLY_SCHEDULE_SETTINGS_N = 'saveWeeklyScheduleSettings_N';
export const CLEAR_WEEKLY_SCHEDULE_N_ISLOADING = 'clearWeeklySchedule_NIsLoading';

// photoUnderline
export const REGISTER_PHOTO_UNDERLINE = 'registerPhotoUnderline';
export const GET_PHOTO_UNDERLINES = 'getPhotoUnderlines';
export const GET_PHOTO_UNDERLINE = 'getPhotoUnderline';
export const EDIT_PHOTO_UNDERLINE = 'editPhotoUnderline';
export const TOGGLE_PHOTO_UNDERLINE_IS_ACTIVE = 'togglePhotoUnderlineIsActive';
export const DELETE_PHOTO_UNDERLINE = 'deletePhotoUnderline';
export const CLEAR_PHOTO_UNDERLINE_ISLOADING = 'clearPhotoUnderlineIsLoading';

// minyanim
export const REGISTER_MINYANIM = 'registerMinyanim';
export const GET_MINYANIMS = 'getMinyanims';
export const GET_MINYANIM = 'getMinyanim';
export const EDIT_MINYANIM = 'editMinyanim';
export const SYNC_MINYANIM = 'syncMinyanim';
export const DELETE_MINYANIM = 'deleteMinyanim';
export const CLEAR_MINYANIM_ISLOADING = 'clearMinyanimIsLoading';

// minyanim_type
export const REGISTER_MINYANIM_TYPE = 'registerMinyanimType';
export const GET_MINYANIM_TYPES = 'getMinyanimTypes';
export const GET_MINYANIM_TYPE = 'getMinyanimType';
export const EDIT_MINYANIM_TYPE = 'editMinyanimType';
export const DELETE_MINYANIM_TYPE = 'deleteMinyanimType';
export const CLEAR_MINYANIM_TYPE_ISLOADING = 'clearMinyanimTypeIsLoading';

// zmanim
export const REGISTER_ZMANIM = 'registerZmanim';
export const GET_ZMANIMS = 'getZmanims';
export const EDIT_ZMANIM = 'editZmanim';
export const DELETE_ZMANIM = 'deleteZmanim';
export const CLEAR_ZMANIM_ISLOADING = 'clearZmanimIsLoading';

// ticket
export const ADD_TICKET = 'addTicket'
export const GET_TICKETS = 'getTickets'
export const DELETE_TICKET = 'deleteTicket'
export const EDIT_TICKET = 'editTicket'
export const CLOSE_TICKET = 'closeTicket'
export const CLEAR_TICKETS_ISLOADING = 'clearTicketsIsLoading'
export const GET_TICKET_UNREAD = 'getTicketUnread'
export const MARK_TICKET_READ = 'markTicketRead'
export const UPSERT_TICKET = 'upsertTicket'
export const CLEAR_TICKET_UNREAD = 'clearTicketUnread'
export const ASSIGN_TICKET = 'assignTicket'
export const SET_TICKET_STATUS = 'setTicketStatus'

// ticket_comment
export const ADD_TICKET_COMMENT = 'addTicketComment'
export const GET_TICKET_COMMENTS = 'getTicketComments'
export const DELETE_TICKET_COMMENT = 'deleteTicketComment'
export const EDIT_TICKET_COMMENT = 'editTicketComment'
export const CLEAR_TICKET_COMMENTS = 'clearTicketComments'
export const CLEAR_TICKET_COMMENTS_ISLOADING = 'clearTicketCommentsIsLoading'

// date_time_banner
export const REGISTER_DATE_TIME_BANNER = 'registerDateTimeBanner'
export const GET_DATE_TIME_BANNERS = 'getDateTimeBanners'
export const DELETE_DATE_TIME_BANNER = 'deleteDateTimeBanner'
export const EDIT_DATE_TIME_BANNER = 'editDateTimeBanner'
export const CLEAR_DATE_TIME_BANNERS = 'clearDateTimeBanners'
export const CLEAR_DATE_TIME_BANNER_ISLOADING = 'clearDateTimeBannerIsLoading'

// sidenav
export const UPDATE_SIDENAV = 'updateSidenav';
export const CLEAR_SIDENAV = 'clearSidenav';

// router_loader
export const UPDATE_ROUTER_LOADER = 'updateRouterLoader';
export const CLEAR_ROUTER_LOADER = 'clearRouterLoader';

// error
export const CLEAR_ERRORMSG = 'clearErrorMessage';
export const UPDATE_ERRORMSG = 'updateErrorMessage';

// zmanim_N
export const REGISTER_ZMANIM_N = 'registerZmanim_N'
export const GET_ZMANIMS_N = 'getZmanims_N'
export const GET_ZMANIM_N = 'getZmanim_N'
export const EDIT_ZMANIM_N = 'editZmanim_N'
export const DELETE_ZMANIM_N = 'deleteZmanim_N'
export const TOGGLE_ZMANIM_N_IS_ACTIVE = 'toggleZmanim_NIsActive'
export const CLEAR_ZMANIM_N_ISLOADING = 'clearZmanim_NIsLoading'

// screen_artboard
export const REGISTER_SCREEN_ARTBOARD = 'registerScreenArtboard';
export const GET_SCREEN_ARTBOARDS = 'getScreenArtboards';
export const GET_SCREEN_ARTBOARD = 'getScreenArtboard';
export const GET_SCREEN_ARTBOARD_CONTENT = 'getScreenArtboardContent';
export const EDIT_SCREEN_ARTBOARD = 'editScreenArtboard';
export const DELETE_SCREEN_ARTBOARD = 'deleteScreenArtboard';
export const CLEAR_SCREEN_ARTBOARD_ISLOADING = 'clearScreenArtboardIsLoading';

// yurtzeiten_N
export const REGISTER_YURTZEITEN_N = 'registerYurtzeiten_N'
export const IMPORT_YURTZEITENS_N = 'importYurtzeitens_N'
export const GET_YURTZEITENS_N = 'getYurtzeitens_N'
export const GET_YURTZEITEN_N = 'getYurtzeiten_N'
export const GET_YURTZEITEN_N_STATS = 'getYurtzeitenStats_N'
export const EDIT_YURTZEITEN_N = 'editYurtzeiten_N'
export const DELETE_YURTZEITEN_N = 'deleteYurtzeiten_N'
export const TOGGLE_YURTZEITEN_N_IS_ACTIVE = 'toggleYurtzeiten_NIsActive'
export const APPROVE_YURTZEITEN_N = 'approveYurtzeiten_N'
export const REJECT_YURTZEITEN_N = 'rejectYurtzeiten_N'
export const MARK_VIEWED_YURTZEITEN_N = 'markViewedYurtzeiten_N'
export const CLEAR_YURTZEITEN_N_ISLOADING = 'clearYurtzeiten_NIsLoading'

// yurtzeiten_N design
export const GET_YURTZEITEN_DESIGN_N = 'getYurtzeitenDesign_N'
export const SAVE_YURTZEITEN_DESIGN_N = 'saveYurtzeitenDesign_N'
export const CLEAR_YURTZEITEN_DESIGN_N_ISLOADING = 'clearYurtzeitenDesign_NIsLoading'

// zmanim display override N
export const REGISTER_ZMANIM_DISPLAY_OVERRIDE_N = 'registerZmanimDisplayOverride_N'
export const GET_ZMANIM_DISPLAY_OVERRIDES_N = 'getZmanimDisplayOverrides_N'
export const GET_ZMANIM_DISPLAY_OVERRIDE_N = 'getZmanimDisplayOverride_N'
export const EDIT_ZMANIM_DISPLAY_OVERRIDE_N = 'editZmanimDisplayOverride_N'
export const DELETE_ZMANIM_DISPLAY_OVERRIDE_N = 'deleteZmanimDisplayOverride_N'
export const TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE = 'toggleZmanimDisplayOverride_NIsActive'
export const CLEAR_ZMANIM_DISPLAY_OVERRIDE_N_ISLOADING = 'clearZmanimDisplayOverride_NIsLoading'

// room
export const REGISTER_ROOM = 'registerRoom';
export const GET_ROOMS = 'getRooms';
export const GET_ROOM = 'getRoom';
export const EDIT_ROOM = 'editRoom';
export const DELETE_ROOM = 'deleteRoom';
export const CLEAR_ROOM_ISLOADING = 'clearRoomIsLoading';

// minyan_roll_N
export const REGISTER_MINYAN_ROLL_N = 'registerMinyanRoll_N'
export const GET_MINYAN_ROLLS_N = 'getMinyanRolls_N'
export const GET_MINYAN_ROLL_N = 'getMinyanRoll_N'
export const EDIT_MINYAN_ROLL_N = 'editMinyanRoll_N'
export const DELETE_MINYAN_ROLL_N = 'deleteMinyanRoll_N'
export const TOGGLE_MINYAN_ROLL_N_IS_ACTIVE = 'toggleMinyanRoll_NIsActive'
export const CLEAR_MINYAN_ROLL_N_ISLOADING = 'clearMinyanRoll_NIsLoading'

// minyan_N
export const REGISTER_MINYAN_N = 'registerMinyan_N'
export const GET_MINYANS_N = 'getMinyans_N'
export const GET_MINYAN_N = 'getMinyan_N'
export const EDIT_MINYAN_N = 'editMinyan_N'
export const DELETE_MINYAN_N = 'deleteMinyan_N'
export const CLEAR_MINYAN_N_ISLOADING = 'clearMinyan_NIsLoading'

// custom_font
export const REGISTER_CUSTOM_FONT = 'registerCustomFont'
export const GET_CUSTOM_FONTS = 'getCustomFonts'
export const EDIT_CUSTOM_FONT = 'editCustomFont'
export const DELETE_CUSTOM_FONT = 'deleteCustomFont'
export const CLEAR_CUSTOM_FONT_ISLOADING = 'clearCustomFontIsLoading'
